export default [
  {
    path: '/mycollege-ask/index',
    name: 'Index',
    component: () => import('@/views/mycollege-ask/index'),
    meta: {
      title: '喊话我的未来大学-高考直通车'
    }
  },
  {
    path: '/mycollege-ask/create',
    name: 'Create',
    component: () => import('@/views/mycollege-ask/create'),
    meta: {
      title: '喊话我的未来大学-高考直通车'
    }
  },
  {
    path: '/mycollege-ask/message',
    name: 'Message',
    component: () => import('@/views/mycollege-ask/message'),
    meta: {
      title: '喊话我的未来大学-高考直通车'
    }
  },
  {
    path: '/mycollege-ask/mymessage',
    name: 'MyMessage',
    component: () => import('@/views/mycollege-ask/mymessage'),
    meta: {
      title: '喊话我的未来大学-高考直通车'
    }
  },
  {
    path: '/mycollege-ask/detail/:id',
    name: 'Detail',
    component: () => import('@/views/mycollege-ask/detail'),
    meta: {
      title: '喊话我的未来大学-高考直通车'
    }
  },
]
